// Auto-generated, do not modify directly

import { api } from './api';

export const ApiService = {
    getUsers: api('/api/users', 'get'),
    getReportsJobsTrend: api('/api/reports/jobs/trend', 'get'),
    getReportsJobsExport: api('/api/reports/jobs/export', 'get'),
    getReportsJobs: api('/api/reports/jobs', 'get'),
    getReportsJobsChannels: api('/api/reports/jobs/channels', 'get'),
    getProfilesById: api('/api/profiles/{id}', 'get'),
    getProfilesByIdServices: api('/api/profiles/{id}/services', 'get'),
    getPartners: api('/api/partners', 'get'),
    postPartners: api('/api/partners', 'post'),
    getLocationsPincodesByPincode: api('/api/locations/pincodes/{pincode}', 'get'),
    getJobsByIdPartners: api('/api/jobs/{id}/partners', 'get'),
    getUsersByIdJobs: api('/api/users/{id}/jobs', 'get'),
    postUsersByIdJobs: api('/api/users/{id}/jobs', 'post'),
    postJobsByIdCancel: api('/api/jobs/{id}/cancel', 'post'),
    getCustomersExport: api('/api/customers/export', 'get'),
    getCustomersByJob: api('/api/customers/by-job', 'get'),
    getCache: api('/api/cache', 'get'),
    postAssignmentsByIdUncomplete: api('/api/assignments/{id}/uncomplete', 'post'),
    getAssignmentsById: api('/api/assignments/{id}', 'get'),
    putAssignmentsById: api('/api/assignments/{id}', 'put'),
    deleteAssignmentsById: api('/api/assignments/{id}', 'delete'),
    getAssignments: api('/api/assignments', 'get'),
    getAddressesById: api('/api/addresses/{id}', 'get'),
    putAddressesById: api('/api/addresses/{id}', 'put'),
    getPing: api('/ping', 'get'),
    postWalletRecharge: api('/api/wallet/recharge', 'post'),
    putUsersByIdTags: api('/api/users/{id}/tags', 'put'),
    getUsersById: api('/api/users/{id}', 'get'),
    getUsersByUserIdDocuments: api('/api/users/{userId}/documents', 'get'),
    postUsersByUserIdCreditLimit: api('/api/users/{userId}/credit-limit', 'post'),
    getUsersByIdAddresses: api('/api/users/{id}/addresses', 'get'),
    postUsersByUserIdActive: api('/api/users/{userId}/active', 'post'),
    postSupportsRequest: api('/api/supports/request', 'post'),
    getStaffs: api('/api/staffs', 'get'),
    postStaffs: api('/api/staffs', 'post'),
    deleteStaffsById: api('/api/staffs/{id}', 'delete'),
    putStaffsByIdPassword: api('/api/staffs/{id}/password', 'put'),
    postSettlements: api('/api/settlements', 'post'),
    getQueues: api('/api/queues', 'get'),
    getProfilesDuplicates: api('/api/profiles/duplicates', 'get'),
    postProfilesDuplicate: api('/api/profiles/duplicate', 'post'),
    putPaymentsById: api('/api/payments/{id}', 'put'),
    deletePaymentsById: api('/api/payments/{id}', 'delete'),
    postPaymentsByIdSend: api('/api/payments/{id}/send', 'post'),
    getPaymentsByIdPdf: api('/api/payments/{id}/pdf', 'get'),
    getPaymentsByIdDownload: api('/api/payments/{id}/download', 'get'),
    getPayments: api('/api/payments', 'get'),
    postPayments: api('/api/payments', 'post'),
    getPartnersByIdSnapshot: api('/api/partners/{id}/snapshot', 'get'),
    getPartnersByIdIncomplete: api('/api/partners/{id}/incomplete', 'get'),
    getPartnersByIdBalance: api('/api/partners/{id}/balance', 'get'),
    getPartnersByIdAccount: api('/api/partners/{id}/account', 'get'),
    getNotes: api('/api/notes', 'get'),
    postNotes: api('/api/notes', 'post'),
    getLocationsById: api('/api/locations/{id}', 'get'),
    putLocationsById: api('/api/locations/{id}', 'put'),
    deleteLocationsById: api('/api/locations/{id}', 'delete'),
    getLocations: api('/api/locations', 'get'),
    postLocations: api('/api/locations', 'post'),
    postLeadByChannel: api('/api/lead/{channel}', 'post'),
    putJobsById: api('/api/jobs/{id}', 'put'),
    postJobsByIdToggle: api('/api/jobs/{id}/toggle', 'post'),
    getJobs: api('/api/jobs', 'get'),
    postJobs: api('/api/jobs', 'post'),
    getJobsByPincode: api('/api/jobs/by-pincode', 'get'),
    getJobsByJobIdAssignments: api('/api/jobs/{jobId}/assignments', 'get'),
    postJobsByJobIdAssign: api('/api/jobs/{jobId}/assign', 'post'),
    getCustomers: api('/api/customers', 'get'),
    getCategoriesById: api('/api/categories/{id}', 'get'),
    putCategoriesById: api('/api/categories/{id}', 'put'),
    deleteCategoriesById: api('/api/categories/{id}', 'delete'),
    getCategories: api('/api/categories', 'get'),
    postCategories: api('/api/categories', 'post'),
    postAssignmentsByIdToggle: api('/api/assignments/{id}/toggle', 'post'),
    postAssignmentsByIdOtpComplete: api('/api/assignments/{id}/otp/complete', 'post'),
    postAssignmentsByIdComplete: api('/api/assignments/{id}/complete', 'post'),
    postAssignmentsByIdAccept: api('/api/assignments/{id}/accept', 'post'),
    postAddressesLatlng: api('/api/addresses/latlng', 'post'),
    getAddresses: api('/api/addresses', 'get'),
    postAddresses: api('/api/addresses', 'post'),
    postActions: api('/api/actions', 'post'),
    getActionsCancels: api('/api/actions/cancels', 'get'),
    getAuthUser: api('/Auth/user', 'get'),
    postChoresMigrate: api('/Chores/migrate', 'post'),
    getReportScheduled: api('/api/Report/scheduled', 'get'),
    getReportScheduledPdf: api('/api/Report/scheduled/pdf', 'get'),
    getTags: api('/api/Tags', 'get'),
};
